import React from 'react';
import { createRoot } from 'react-dom/client';

import AdminApp from './AdminApp';
import ClienteApp from './ClienteApp';
import './ds/estilos/estilos.css';
import { ProvedorNotificacoes } from './estado/notificacoes';
import { ProvedorPreferencias } from './estado/preferencias';
import { ProvedorSessao } from './estado/sessao';

// Duas estruturas, uma por URL. `/admin` é a porta do painel administrativo; o
// resto é o painel do cliente. Mesma sessão (cookie same-origin), portas
// separadas — quem autoriza é o backend, por rota e escopo.
const ehAdmin = window.location.pathname.replace(/\/+$/, '').startsWith('/admin');
const Raiz = ehAdmin ? AdminApp : ClienteApp;

/* `StrictMode` fica ligado: em desenvolvimento ele monta cada efeito duas
   vezes, o que expõe busca sem cancelamento e assinatura sem limpeza — os dois
   defeitos que aparecem exatamente numa tela que fica aberta o turno inteiro. */
createRoot(document.getElementById('raiz')).render(
  <React.StrictMode>
    <ProvedorPreferencias>
      <ProvedorNotificacoes>
        <ProvedorSessao>
          <Raiz />
        </ProvedorSessao>
      </ProvedorNotificacoes>
    </ProvedorPreferencias>
  </React.StrictMode>,
);
